<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="d-flex justify-content-between align-items-center mb-4 px-3">
                    <div>
                        <h5 class="text-white mb-0">Panel de Control</h5>
                        <p class="text-white text-sm opacity-8">Resumen operativo de la empresa</p>
                    </div>
                    <div class="header-filters-container">


                        <div class="input-group input-group-sm shadow-sm year-select-box">
                                <span class="input-group-text bg-white border-0 text-success">
                                    <i class="fa fa-calendar"></i>
                                </span>
                                <select
                                    v-model="selectedYear"
                                    @change="fetchDashboardData"
                                    class="form-select border-0 font-weight-bold"
                                >
                                    <option v-for="year in availableYears" :key="year" :value="year">
                                        {{ year }}
                                    </option>
                                </select>
                            </div>


                        <div class="months-scroll-container">
                                <div class="months-wrapper bg-glass shadow-sm">
                                    <button
                                        @click="setMonth(0)"
                                        :class="['month-pill', selectedMonth === 0 ? 'active-pill' : 'inactive-pill']"
                                    >
                                        Todo el Año
                                    </button>

                                    <button
                                        v-for="m in 12"
                                        :key="m"
                                        @click="setMonth(m)"
                                        :class="['month-pill', selectedMonth === m ? 'active-pill' : 'inactive-pill']"
                                    >
                                        {{ monthNames[m-1] }}
                                    </button>
                                </div>
                            </div>
                        </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-6 col-12">
                        <card
                            :title="stats.sales.title"
                            :value="stats.sales.value"
                            :percentage="stats.sales.percentage"
                            :iconClass="stats.sales.iconClass"
                            :iconBackground="stats.sales.iconBackground"
                            :detail="stats.sales.detail"
                            directionReverse
                        ></card>
                    </div>
                    <div class="col-lg-3 col-md-6 col-12">
                        <card
                            :title="stats.clients.title"
                            :value="stats.clients.value"
                            :percentage="stats.clients.percentage"
                            :iconClass="stats.clients.iconClass"
                            :iconBackground="stats.clients.iconBackground"
                            :percentageColor="stats.clients.percentageColor"
                            :detail="stats.clients.detail"
                            directionReverse
                        ></card>
                    </div>
                    <div class="col-lg-3 col-md-6 col-12">
                        <card
                            :title="stats.money.title"
                            :value="stats.money.value"
                            :percentage="stats.money.percentage"
                            :iconClass="stats.money.iconClass"
                            :iconBackground="stats.money.iconBackground"
                            :detail="stats.money.detail"
                            directionReverse
                        ></card>
                    </div>
                    <div class="col-lg-3 col-md-6 col-12">
                        <card
                            :title="stats.users.title"
                            :value="stats.users.value"
                            :percentage="stats.users.percentage"
                            :iconClass="stats.users.iconClass"
                            :iconBackground="stats.users.iconBackground"
                            :detail="stats.users.detail"
                            directionReverse
                        ></card>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-7 mb-lg">
                        <div class="card z-index-2">
                            <gradient-line-chart
                            :chart-data="productSalesData"
                            />
                        </div>
                    </div>
                    <div class="col-lg-5">
                        <categories-card :top-clients-data="topClientsData"/>
                    </div>
                </div>

                <div class="row mt-4">
                    <div class="col-lg-12">
                        <div class="card">
                            <div class="p-3 pb-0 card-header">
                                <h6 class="mb-2">Ventas por Asesor/Vendedor (Resumen)</h6>
                            </div>

                            <div v-if="isLoading" class="p-4 text-center">
                                <i class="fa fa-spinner fa-spin text-primary"></i> Cargando datos de ventas...
                            </div>

                            <div v-else class="table-responsive">
                                <table class="table align-items-center mb-0">
                                    <thead>
                                        <tr>
                                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">#</th>
                                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Asesor</th>
                                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Nombre Completo</th>
                                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">Facturas Emitidas</th>
                                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-end">Total Vendido</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(advisor, index) in advisorSalesData" :key="index">
                                            <td class="ps-4">
                                                <p class="mb-0 text-xs font-weight-bold">{{ index + 1 }}</p>
                                            </td>
                                            <td>
                                                <p class="mb-0 text-xs font-weight-bold">{{ advisor.advisor_username }}</p>
                                            </td>
                                            <td>
                                                <p class="mb-0 text-sm">{{ advisor.advisor_name }}</p>
                                            </td>
                                            <td class="text-center">
                                                <span class="text-xs font-weight-bold">{{ advisor.total_invoices }}</span>
                                            </td>
                                            <td class="text-sm align-middle text-end">
                                                <span class="text-xs font-weight-bold text-success">{{ formatTableCurrency(advisor.total_sales) }}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div v-if="!advisorSalesData.length" class="p-4 text-center text-muted">
                                    No se encontraron ventas por asesor para el período.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Card from "@/examples/Cards/Card.vue";
import GradientLineChart from "@/views/clinic-lab/Dashboard/Components/Charts/GradientLineChart.vue";
import CategoriesCard from "@/views/clinic-lab/Dashboard/Components/Cards/CategoriesCard.vue";

import axios from "axios";
import { formatCurrency } from '@/composables/useUtils';
import Swal from 'sweetalert2';

const companyId = localStorage.getItem('companyId');

export default {
    name: "dashboard-default",
    data() {
        return {
            selectedYear: new Date().getFullYear(),
            selectedMonth: new Date().getMonth() + 1, // Mes actual por defecto
            availableYears: [],
            monthNames: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
            currentPeriod: 'year',
            isLoading: true,
            currencySymbol: '$',
            advisorSalesData: [],
            // 💡 Data para el gráfico de productos/tendencias
            productSalesData: [],
            topClientsData: [],
            stats: {
                sales: {
                    title: "VENTAS",
                    value: "0.00",
                    percentage: "",
                    iconClass: "fa fa-chart-line",
                    iconBackground: "bg-success",
                    detail: "",
                },
                clients: {
                    title: "FACTURAS",
                    value: "0",
                    percentage: "",
                    iconClass: "fa fa-file-invoice-dollar",
                    iconBackground: "bg-info",
                    detail: "",
                },
                money: {
                    title: "IMPUESTOS",
                    value: "0.00",
                    percentage: "",
                    iconClass: "fa fa-hand-holding-usd",
                    iconBackground: "bg-warning",
                    detail: "",
                },
                users: {
                    title: "CLIENTES",
                    value: "0",
                    percentage: "",
                    iconClass: "fa fa-users",
                    iconBackground: "bg-primary",
                    detail: "",
                },
            },
        };
    },
    components: {
        Card,
        GradientLineChart,
        CategoriesCard,
    },
    mounted() {
        this.generateAvailableYears();
        this.fetchDashboardData();
    },
    methods: {
        generateAvailableYears() {
            const currentYear = new Date().getFullYear();
            // Genera un rango de 5 años hacia atrás
            for (let i = 0; i < 5; i++) {
                this.availableYears.push(currentYear - i);
            }
        },
        setMonth(m) {
            this.selectedMonth = m;
            this.fetchDashboardData();
        },
        setPeriod(period) {
                this.currentPeriod = period;
                //this.productSalesData = [];
                this.fetchDashboardData();
            },
        // 🆕 FUNCIÓN: Conteo total de clientes
        async fetchClientCount() {
            const token = localStorage.getItem("accessToken");
            const apiURL = this.$store.state.apiURL;
            try {
                // 🛑 Asume un endpoint /clients con un filtro que devuelve el total de registros 🛑
                // NOTA: Si tu API no tiene /clients/count, esta ruta obtiene todos los clientes y cuenta.
                const response = await axios.get(`${apiURL}clients?company=${companyId}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                return response.data.length || 0;
            } catch (error) {
                this.handleErrorLogin();
                return 0;
            }
        },

        async fetchCompanyConfig() {
            const token = localStorage.getItem("accessToken");
            try {
                const response = await axios.get(this.$store.state.apiURL + 'company_config?id=' + companyId, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                const config = response.data.length ? response.data[0] : {};
                this.currencySymbol = config.currency_symbol || '$';
            } catch (error) {
                this.handleErrorLogin();
            }
        },

        async fetchReportData(reportType, startDate, endDate) {
            const token = localStorage.getItem("accessToken");
            const apiURL = this.$store.state.apiURL;
            const params = {
                company_id: parseInt(companyId),
                type: reportType,
                start_date: startDate,
                end_date: endDate,
            };
            const queryString = new URLSearchParams(params).toString();

            try {
                const response = await axios.get(`${apiURL}reports/invoices?${queryString}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                return response.data.data || [];
            } catch (err) {
               this.handleErrorLogin();
            }
        },

        async fetchDashboardData() {
            try {
                this.isLoading = true;
                await this.fetchCompanyConfig();

                let startDate, endDate;

                // --- LÓGICA DE CÁLCULO DE FECHAS PRO ---
                if (this.selectedMonth === 0) {
                    // RANGO: Todo el año seleccionado
                    startDate = `${this.selectedYear}-01-01`;
                    endDate = `${this.selectedYear}-12-31`;
                    //this.stats.sales.detail = `Acumulado anual ${this.selectedYear}`;
                } else {
                    // RANGO: Mes específico del año seleccionado
                    const monthStr = this.selectedMonth.toString().padStart(2, '0');
                    startDate = `${this.selectedYear}-${monthStr}-01`;

                    // Calculamos el último día del mes seleccionado
                    const lastDay = new Date(this.selectedYear, this.selectedMonth, 0).getDate();
                    endDate = `${this.selectedYear}-${monthStr}-${lastDay}`;

                    //this.stats.sales.detail = `Cierre de ${this.monthNames[this.selectedMonth - 1]} ${this.selectedYear}`;
                }

                // 1. Obtener datos de ventas generales
                const salesDataPeriod = await this.fetchReportData('date', startDate, endDate);

                let totalSales = 0;
                let totalTaxes = 0;
                let totalInvoices = 0;

                if (salesDataPeriod && salesDataPeriod.length > 0) {
                    totalSales = salesDataPeriod.reduce((sum, item) => sum + parseFloat(item.total || 0), 0);
                    totalTaxes = salesDataPeriod.reduce((sum, item) => sum + parseFloat(item.total_taxes || 0), 0);
                    totalInvoices = salesDataPeriod.length;
                }

                // 2. Obtener reportes segmentados usando el nuevo rango
                // Usamos Promise.all para que las peticiones corran en paralelo (más rápido)
                const [advisors, products, clients, clientCount] = await Promise.all([
                    this.fetchReportData('advisor', startDate, endDate),
                    this.fetchReportData('product', startDate, endDate),
                    this.fetchReportData('client', startDate, endDate),
                    this.fetchClientCount()
                ]);

                this.advisorSalesData = advisors;
                this.productSalesData = products;
                this.topClientsData = clients;

                // 3. Actualizar tarjetas de estadísticas
                this.stats.sales.value = this.formatTableCurrency(totalSales);
                this.stats.clients.value = totalInvoices.toString();
                this.stats.money.value = this.formatTableCurrency(totalTaxes);
                this.stats.users.value = clientCount.toString();

                this.isLoading = false;
            } catch (error) {
                console.error("Dashboard Error:", error);
                this.handleErrorLogin();
            }
        },

        // Helper para formatear valores monetarios en la tabla y las tarjetas
        formatTableCurrency(value) {
            const num = parseFloat(value);
            return formatCurrency(num, 'USD', this.currencySymbol);
        },
        handleErrorLogin(){
            console.log('error');
            let self=this;
            Swal.fire({
                    title: 'Sesión',
                    text: 'El tiempo de sesión ha vencido, ingresa nuevamente.',
                    icon:'warning',
                    showCancelButton: false,
                    confirmButtonColor:'#bf4f51',
                    showCloseButton: true,
                    showLoaderOnConfirm: false
                }).then(function(){
                    localStorage.removeItem('user');
                    localStorage.removeItem('accessToken');
                    self.$router.push('/signin');
                });
        }
    }
};
</script>
<style scoped>
/* Puedes agregar esto en una sección <style> */
.btn-outline-white {
    color: #fff;
    border-color: rgba(255, 255, 255, 0.6);
}
.btn-outline-white:hover {
    background-color: rgba(255, 255, 255, 0.1);
}
.btn-white.text-primary {
    background-color: #fff !important;
    box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
    font-weight: bold;
}
.bg-white-transparent {
    background-color: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
}



/* --- Estructura Responsiva de Filtros --- */
.header-filters-container {
    display: flex;
    flex-direction: column; /* Apilado en Mobile por defecto */
    align-items: flex-start;
    gap: 15px; /* Espaciado entre año y meses */
    width: 100%;
    margin-bottom: 25px;
}

.year-select-box {
    width: 80% !important; /* Selector de año ocupa todo el ancho en mobile */
    height: 44px;
}

/* --- Cinta de Meses Desplazable (Scroll Horizontal) --- */
.months-scroll-container {
    width: 80%;
    overflow-x: auto; /* IMPORTANTE: Habilita el scroll horizontal */
    overflow-y: hidden;
    display: block;
    -webkit-overflow-scrolling: touch; /* Scroll suave y nativo en iOS */
    padding-bottom: 6px; /* Espacio para que no se corte la sombra */
}

.months-wrapper {
    display: flex;
    flex-wrap: nowrap; /* IMPORTANTE: Evita que los meses salten de línea */
    gap: 8px; /* Espaciado entre píldoras */
    padding: 6px;
    border-radius: 12px;
    width: max-content; /* Obliga al contenedor a estirarse según el contenido */
    min-width: 100%;
    border: 1px solid rgba(255, 255, 255, 0.2);
}

/* --- Estética y Visibilidad "Glassmorphism" --- */
.bg-glass {
    background-color: rgba(255, 255, 255, 0.12) !important;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
}

.month-pill {
    padding: 6px 10px;
    border-radius: 8px;
    font-size: 0.75rem;
    font-weight: 600;
    border: none;
    transition: all 0.2s ease;
    white-space: nowrap; /* Evita que nombres largos se corten */
    cursor: pointer;
}

/* --- Visibilidad y Contraste de Colores --- */

/* Mes Inactivo: Texto blanco con opacidad, totalmente legible sobre el azul */
.inactive-pill {
    background: transparent;
    color: rgba(255, 255, 255, 0.85) !important;
}

.inactive-pill:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #fff !important;
}

/* Mes Activo: Fondo blanco sólido, texto azul primary */
.active-pill {
    background: #fff !important;
    color: #0b9257 !important; /* Tu color primario (ej. #5e72e4 de Argon) */
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
    transform: translateY(-1px);
}

/* --- Ocultar barra de scroll estéticamente --- */
.months-scroll-container::-webkit-scrollbar {
    height: 0px;
}
.months-scroll-container::-webkit-scrollbar-thumb {
    background-color: transparent;
}
.months-scroll-container {
    -ms-overflow-style: none; /* IE y Edge */
    scrollbar-width: none; /* Firefox */
}

/* --- Media Queries para ESCRITORIO (min-width: 992px) --- */
@media (min-width: 992px) {
    .header-filters-container {
        flex-direction: row; /* Alineado horizontal en PC */
        align-items: center;
        justify-content: flex-start; /* Alineado a la izquierda */
        gap: 15px;
    }

    .year-select-box {
        width: 140px !important; /* Ancho fijo en PC para el año */
    }

    .months-scroll-container {
        overflow-x: hidden; /* Quitamos el scroll en PC */
    }

    .months-wrapper {
        flex-wrap: wrap; /* Permitimos que se acomoden si el espacio es poco en PC */
        justify-content: flex-start;
        width: 100%;
    }
}
</style>